import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Add } from './components/Add';

const AddReplacements = ({ disabled }) => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý thay thế lắp mới', path: '/replacements' },
            { name: 'Khai báo thông tin' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Add disabled={disabled} />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddReplacements;
